import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Heading from 'LuxKit/Typography/Heading'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import DreamBlockItem from './DreamBlockItem'
import LayoutContainer from 'components/Common/LayoutContainer'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { skip, take } from 'lib/array/arrayUtils'
import useToggle from 'hooks/useToggle'
import TextButton from 'LuxKit/Button/TextButton'
import Expander from 'components/utils/Expander'

const Wrapper = styled.div`
  padding: ${rem(40)} 0;
  background: ${props => props.theme.palette.neutral.surface.normalBackground};

  > * + * {
    margin-top: ${rem(40)};
  }
`

const VerticalItems = styled(CSSBreakpoint)`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
`

export interface Props {
  tiles: Array<App.HubTile>
  title: string
}

function DreamBlock({ tiles, title }: Props) {
  const intl = useIntl()
  const [showMore, toggleShowMore] = useToggle()

  const viewLessLabel = intl.formatMessage({ id: '99xKxz6TosCKSaEMRM4D', defaultMessage: 'View less', description: 'Button to collapse and show fewer dream block items' })
  const viewMoreLabel = intl.formatMessage({ id: '5ktYc4yPqusrakAx0e6G', defaultMessage: 'View more', description: 'Action button to expand and show more dream block items' })

  return (
    <Wrapper>
      <Heading align="center" variant="heading3">{title}</Heading>
      <LayoutContainer>
        <CSSBreakpoint min="tablet">
          <CardCarousel pageSize={4} width={rem(270)}>
            {tiles.map((tile, index) => <DreamBlockItem {...tile} key={index} />)}
          </CardCarousel>
        </CSSBreakpoint>
        <VerticalItems max="mobile">
          {take(tiles, 3).map((tile, index) => <DreamBlockItem {...tile} key={index} />)}
          {tiles.length > 3 && <>
            <Expander expanded={showMore}>
              {skip(tiles, 3).map((tile, index) => <DreamBlockItem {...tile} key={index} />)}
            </Expander>
            <TextButton kind="secondary" onClick={toggleShowMore}>
              {showMore ? viewLessLabel : viewMoreLabel}
            </TextButton>
          </>}
        </VerticalItems>
      </LayoutContainer>
    </Wrapper>
  )
}

export default DreamBlock
